// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type WhitelabelContextProperties = {
  wl_partner: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/whitelabel_context/jsonschema/1-0-4';
export const whitelabelContextName = 'whitelabel_context';
export class WhitelabelContext extends BaseTrackingContext<WhitelabelContextProperties> {
  constructor(properties: WhitelabelContextProperties) {
    super(whitelabelContextName, schema, properties);
  }
}
